import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-chart-pie-icon',
  templateUrl: 'chart-pie-icon.component.html'
})
export class ChartPieIconComponent {
  constructor() {}
}
